import classNames from "classnames";
import style from "./GuidelineMenuLink.module.scss";
import icons from "../../scss/guidelineicons.module.scss";
import PropTypes from "prop-types";
import kugNewTag from "../../assets/images/kug_new_tag.svg";

const GuidelineMenuLink = ({ iconClassSuffix, linkText, onClickAction, showArrowIcon = true }) => {
  return (
    <div
      className={style.guidelineMenu}
      role="button"
      onClick={onClickAction}
      aria-label={`${linkText}-breadcrumb`}
    >
      <span className={classNames(icons[iconClassSuffix], style.guidelineIcon)} />
      {linkText}
      {linkText === "Kidney and Urinary" && (
        <img src={kugNewTag} alt="New" className={style.newTag} />
      )}
      {showArrowIcon && (
        <button type="button" className={style.button} data-testid="arrowButton">
          <i className={"fa tg-icons-Carat"}></i>
        </button>
      )}
    </div>
  );
};

GuidelineMenuLink.propTypes = {
  iconClassSuffix: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  onClickAction: PropTypes.func.isRequired,
  showArrowIcon: PropTypes.bool,
};

export default GuidelineMenuLink;
